import * as React from 'react';
import { isNullOrUndefined } from 'util';
import Popover from '@mulesoft/anypoint-components/lib/Popover';
import Menu from '@mulesoft/anypoint-components/lib/Menu';
import MenuItem from '@mulesoft/anypoint-components/lib/MenuItem';
import IconPanel from '@mulesoft/anypoint-icons/lib/Icon';
import './PopOver.css'

export type ValueProps = {
  options: { icon?: string, label: string, onClick: () => void , testId?: string, disabled?: boolean }[],
  icon: string,
  iconSize?: string | number,
  iconColor?: string,
  clazz: string,
  pid: string
}

export type EventProps = {}

export type Props = ValueProps & EventProps

class PopOverMenu extends React.Component<Props, {}> {

  render() {
    const {options, icon, iconSize, iconColor, clazz, pid} = this.props;
    
    return (
      <div>
        <Popover
            triggerOn={['click']}
            closeOnClickInside={true}
            closeOnClickOutside={true}
            anchorPosition={'br'}
            popupPosition={'tr'}
            content={
               <Menu className={`${clazz} popover-menu`}>
                 {
                   options.map((item, index) => (
                     <MenuItem
                         key={`popover-menu-item-${index}`}
                         onClick={this.onClick(item.onClick)}
                         disabled={item.disabled}
                         icon={item.icon}
                         testId={item.testId}
                     >
                       {item.label}
                     </MenuItem>
                   ))
                 }
               </Menu>}
        >
          <div id={pid}>
            <IconPanel className={'popover-icon'} name={icon} fill={iconColor ? iconColor : '#3A3B3C'} size={iconSize ? iconSize : 25}/>
          </div >
        </Popover>
      </div>

    )
  }

  onClick(f: () => void) {
    return () => {
      f();
      // workaround because the 'closeOnClickInside' property doesn't work
      const popoverIcon = document.getElementById(this.props.pid);
      if (!isNullOrUndefined(popoverIcon)) {
        popoverIcon.click()
      }
    }
  }
}

export default PopOverMenu
